import { FunctionComponent, useState } from 'react'
import { MdCheck, MdPlayArrow } from 'react-icons/md'
import { useHistory } from 'react-router-dom'
import * as Yup from 'yup'
import { FormikValues } from 'formik'

import SizedBox from 'shared/components/SizedBox'
import {
  loginEvent,
  registerEvent,
  setUserPropertiesFirebase,
} from 'shared/services/TrackingGAService'
import dimensions from 'shared/styles/dimensions'
import { colors } from 'shared/styles/colors'
import logoTmov from 'shared/assets/images/logoTmov.svg'

import Button from 'shared/components/Button'
import Form from 'shared/components/Form'
import Input from 'shared/components/Input'

import { IAuthContextState } from 'modules/auth/hooks/auth'

import { ISignIn } from '../../domain/usecases/SignInImpl'
import {
  Container,
  Logo,
  ContainerForm,
  FormWrapper,
  Forgot,
  TextLoginPage,
  Footer,
  Divider,
  ContainerForgot,
} from './styles'

type TProps = {
  signIn: ISignIn
  signInStore: IAuthContextState['signIn']
}

const SignInScreen: FunctionComponent<TProps> = ({ signIn, signInStore }) => {
  const [errorMessage, setErrorMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  const handleSubmit = async (values: FormikValues) => {
    setErrorMessage('')
    setLoading(true)

    try {
      const response = await signIn.execute({
        username: values.username,
        password: values.password,
      })

      setLoading(false)

      setUserPropertiesFirebase({
        id: response.usuario_id.toString(),
        profile: response.perfil,
        name: response.name,
      })

      loginEvent()

      signInStore({ ...response, user: values.username })

      history.push('/lotes')
    } catch (e: unknown) {
      setLoading(false)

      if (e instanceof Error) {
        if (e.message === 'Network Error') {
          setErrorMessage('Serviço indisponível no momento.')
          return
        }
        if (e.message === 'Invalid user credentials') {
          setErrorMessage('Credenciais inválidas')
          return
        }
        if (e.message === 'Account disabled') {
          setErrorMessage('Conta em análise, aguarde a confirmação por e-mail.')
          return
        }
        setErrorMessage(e.message)
      } else {
        setErrorMessage('Erro ao tentar logar na plataforma frotista')
      }
    }
  }

  return (
    <Container>
      <Logo src={logoTmov} />
      <ContainerForm>
        <TextLoginPage>Entrar</TextLoginPage>
        <Form
          onSubmit={values => handleSubmit(values)}
          initialValues={{
            username: '',
            password: '',
          }}
          validationSchema={() => ({
            username: Yup.string().email('Email inválido!').required(),
            password: Yup.string().required('Senha inválida!'),
          })}
        >
          {formControl => (
            <FormWrapper>
              <Input
                placeholder="Digite seu e-mail"
                name="username"
                type="email"
                mask={value => value.toLowerCase()}
                formControl={formControl}
                errorMessage={''}
              />
              <SizedBox size={dimensions.spaces.large} />
              <Input
                placeholder="Digite sua senha"
                name="password"
                type="password"
                formControl={formControl}
                errorMessage={errorMessage}
              />

              <Button
                color={colors.green}
                type="submit"
                onClick={formControl.handleSubmit}
                disabled={!formControl.isValid || loading}
                loading={loading}
              >
                <MdPlayArrow /> Entrar
              </Button>

              <ContainerForgot>
                <Forgot to="/forgot">Esqueceu sua senha?</Forgot>
              </ContainerForgot>
            </FormWrapper>
          )}
        </Form>
      </ContainerForm>
      <Footer>
        <TextLoginPage>Ou cadastre-se agora</TextLoginPage>

        <Button
          onClick={() => {
            registerEvent({
              categoria: 'Cadastro de Frotista',
              acao: 'Click Começar',
              local: 'Botao na tela de login',
            })

            history.push('/signup')
          }}
          color={colors.orange}
          type="button"
        >
          <MdCheck /> Começar
        </Button>
      </Footer>
    </Container>
  )
}

export default SignInScreen
